<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    components: {},
    data() {
        return {};
    },
    mounted() {
        // this.loopDebuger();
    },
    created() {
        let userChrome = this.checkChrome();
        if (userChrome == "IE" || "Edge" == userChrome) {
            this.$message.error({
                message: "请使用IE 11+ 以上版本的浏览器打开(例如：谷歌浏览器)",
                duration: 5000,
            });
        }
    },
    methods: {
        checkChrome() {
            let userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
            let isOpera = userAgent.indexOf("Opera") > -1;
            //判断是否Opera浏览器
            if (isOpera) {
                return "Opera";
            }
            //判断是否Firefox浏览器
            if (userAgent.indexOf("Firefox") > -1) {
                return "FF";
            }
            //判断是否chorme浏览器
            if (userAgent.indexOf("Chrome") > -1) {
                return "Chrome";
            }
            //判断是否Safari浏览器
            if (userAgent.indexOf("Safari") > -1) {
                return "Safari";
            }
            //判断是否IE浏览器
            if (
                userAgent.indexOf("compatible") > -1 &&
                userAgent.indexOf("MSIE") > -1 &&
                !isOpera
            ) {
                return "IE";
            }
            //判断是否Edge浏览器
            if (userAgent.indexOf("Trident") > -1) {
                return "Edge";
            }
        },
        // loopDebuger() {
        //     let $this = this;
        //     const handler = setInterval(() => {
        //         const before = new Date();
        //         debugger;
        //         const after = new Date();
        //         // 如果不打开调试模式的话,肯定不会大于100
        //         const cost = after.getTime() - before.getTime();
        //         if (cost > 100) {
        //             $this.handlercallback(); // 这个是执行回调
        //             clearInterval(handler);
        //         }
        //     }, 200);
        // },
        // handlercallback() {
        //     this.$router.go(0);
        // },
    },
};
</script>
<style lang="scss" scoped>
#app {
    width: 100%;
    height: 100vh;
    padding: 0;
    margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/App.vue